import { file } from "jszip";
import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class BackupAndRestoreService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  restoreUsersAndGroupsConfigurations = async (session_id, configData) => {
    try {
      return await this.HttpService.postJson(
        this.constants.RestoreURLS.UsersAndGroupsConfigRestore,
        configData,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  restoreCrmConfigurations = async (session_id, configData) => {
    try {
      return await this.HttpService.postJson(
        this.constants.RestoreURLS.crmConfigRestore,
        configData,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadUsersAndGroupsBackupFile = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.RestoreURLS.UsersAndGroupsConfigBackup,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAccountConfigurationsCount = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.RestoreURLS.getAccountConfigurationsCount,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadCrmBackupFile = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.RestoreURLS.CrmConfigBackup,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadPromptsBackupFolder = async (session_id, filename) => {
    try {
      let filesList = await this.HttpService.downloadFile(
        this.constants.RestoreURLS.promptsConfigBackup,

        session_id
      );

      var a = window.document.createElement("a");

      a.href = filesList;
      a.download = filename + "_PF";

      // Append anchor to body.
      document.body.appendChild(a);
      a.click();

      // Remove anchor from body
      document.body.removeChild(a);
    } catch (e) {
      throw e;
    }
  };

  restorePrompts = async (session_id, file, data) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.RestoreURLS.promptsConfigRestore,
        file,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadCallFlowsBackupFolder = async (session_id, filename) => {
    try {
      let filesList = await this.HttpService.downloadFile(
        this.constants.RestoreURLS.callFlowsConfigBackup,
        session_id
      );


      var a = window.document.createElement("a");

      a.href = filesList;
      a.download = filename + "_CF";

      // Append anchor to body.
      document.body.appendChild(a);
      a.click();

      // Remove anchor from body
      document.body.removeChild(a);
    } catch (e) {
      throw e;
    }
  };

  restoreCallFlows = async (session_id, file, data) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.RestoreURLS.callFlowsConfigRestore,
        file,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
